export const ENVIRONMENT_BANNER_HEIGHT_CLASS = "h-8";
export const ENVIRONMENT_BANNER_TOP_OFFSET_CLASS = "top-8";
